<template>
    <v-row>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <select-input
                v-model="value.timeFrom"
                v-validate.immediate="'required|integer|between:0,23'"
                :items="hours"
                :label="$t('labels.from')"
                :data-vv-as="$t('labels.from')"
                :name="`timeFrom${index}`"
                :error-messages="errors.collect(`timeFrom${index}`)"
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <select-input
                v-model="value.timeTo"
                v-validate.immediate="'required|integer|between:0,23'"
                :items="hours"
                :label="$t('labels.to')"
                :data-vv-as="$t('labels.to')"
                :name="`timeTo${index}`"
                :error-messages="errors.collect(`timeTo${index}`)"
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <text-input
                v-model="value.pickupDayOffset"
                v-validate.immediate="'integer'"
                type="number"
                :label="$t('labels.delivery_rule.pickup_day_offset')"
                :data-vv-as="$t('labels.delivery_rule.pickup_day_offset')"
                :name="`pickupDayOffset${index}`"
                :error-messages="errors.collect(`pickupDayOffset${index}`)"
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <entity-select-input
                v-model="value.deliveryMethod"
                v-validate.immediate="'required'"
                v-tab-error:deliveryRules
                label="labels.delivery_rule.delivery_method"
                :data-vv-as="$t('labels.delivery_rule.delivery_method')"
                :entity="selectApiClientType.DELIVERY_METHOD"
                :name="`deliveryMethod${index}`"
                translate-items
                :error-messages="errors.collect(`deliveryMethod${index}`)"
            ></entity-select-input>
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <entity-select-input
                v-model="value.preventInProgressDeliveryMethod"
                v-validate.immediate=""
                :entity="selectApiClientType.DELIVERY_METHOD"
                :label="
                    $t(
                        'labels.delivery_rule.prevent_in_progress_delivery_method'
                    )
                "
                :data-vv-as="
                    $t(
                        'labels.delivery_rule.prevent_in_progress_delivery_method'
                    )
                "
                :name="`preventInProgressDeliveryMethod${index}`"
                :error-messages="
                    errors.collect(`preventInProgressDeliveryMethod${index}`)
                "
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <select-input
                v-model="value.preventInProgressWeekDays"
                v-validate.immediate=""
                multiple
                :items="days"
                :label="$t('labels.delivery_rule.prevent_in_progress_weekdays')"
                :data-vv-as="
                    $t('labels.delivery_rule.prevent_in_progress_weekdays')
                "
                :name="`preventInProgressWeekDays${index}`"
                :error-messages="
                    errors.collect(`preventInProgressWeekDays${index}`)
                "
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <text-input
                v-model="value.preventInProgressTimeFrom"
                :rules="[validateTime]"
                :label="
                    $t('labels.delivery_rule.prevent_in_progress_time_from')
                "
                :data-vv-as="
                    $t('labels.delivery_rule.prevent_in_progress_time_from')
                "
                :name="`preventInProgressTimeFrom${index}`"
                :error-messages="
                    errors.collect(`preventInProgressTimeFrom${index}`)
                "
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <text-input
                v-model="value.preventInProgressTimeTo"
                :rules="[validateTime]"
                :label="$t('labels.delivery_rule.prevent_in_progress_time_to')"
                :data-vv-as="
                    $t('labels.delivery_rule.prevent_in_progress_time_to')
                "
                :name="`preventInProgressTimeTo${index}`"
                :error-messages="
                    errors.collect(`preventInProgressTimeTo${index}`)
                "
                translate-items
            />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <entity-select-input
                v-model="value.onfleetTeam"
                :label="$t('labels.delivery_rule.onfleet_team')"
                :data-vv-as="$t('labels.delivery_rule.onfleet_team')"
                :entity="selectApiClientType.ONFLEET_TEAMS"
                :name="`onfleetTeam${index}`"
                :error-messages="errors.collect(`onfleetTeam${index}`)"
                translate-items
            />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="2" xl="1">
            <checkbox-input
                v-model="value.onfleetForceOfflineDriverUnassign"
                :label="
                    $t(
                        'labels.delivery_rule.onfleet_force_offline_driver_unassign'
                    )
                "
                :data-vv-as="
                    $t(
                        'labels.delivery_rule.onfleet_force_offline_driver_unassign'
                    )
                "
                :name="`onfleetTeam${index}`"
                :error-messages="errors.collect(`onfleetTeam${index}`)"
                translate-items
            />
        </v-col>
        <v-col
            cols="12"
            sm="4"
            md="3"
            lg="2"
            xl="1"
            class="align-center d-flex pb-6"
        >
            <v-btn
                text
                icon
                color="blue-grey"
                @click="deleteConfirmModal = true"
            >
                <v-icon>delete</v-icon>
            </v-btn>
        </v-col>
        <confirm-modal
            :value="deleteConfirmModal"
            :title="$t('texts.are_you_sure')"
            :approve-text="$t('actions.delete')"
            :cancel-text="$t('actions.cancel')"
            @onApprove="deleteRule"
            @onCancel="deleteConfirmModal = false"
        ></confirm-modal>
    </v-row>
</template>

<script>
import { Validator } from 'vee-validate'
import FormBase from '@/components/mixins/FormBase'
import ActiveTabMixin from '@/components/mixins/ActiveTabMixin'
import FormTabMixin from '@/components/mixins/FormTabMixin'
import AuthMixin from '@/components/mixins/AuthMixin'
import TextInput from '@/components/form/Inputs/TextInput.vue'
import SelectInput from '@/components/form/Inputs/SelectInput.vue'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput.vue'
import CheckboxInput from '@/components/form/Inputs/CheckboxInput.vue'
import ConfirmModal from '@/components/confirm/ConfirmModal.vue'

Validator.extend('from_should_be_less_than_to', {
    getMessage: (field, args) => {
        return args[1] || 'The value is invalid'
    },
    validate(value, args) {
        const to = args[0]
        return Number(value) < Number(to)
    },
})

Validator.extend('to_should_be_greater_than_from', {
    getMessage: (field, args) => {
        return args[1] || 'The value is invalid'
    },
    validate(value, args) {
        const from = args[0]
        return Number(value) > Number(from)
    },
})

export default {
    components: {
        ConfirmModal,
        CheckboxInput,
        EntitySelectInput,
        SelectInput,
        TextInput,
    },
    mixins: [FormBase, ActiveTabMixin, FormTabMixin, AuthMixin],
    props: {
        value: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            deleteConfirmModal: false,
        }
    },
    computed: {
        hours() {
            let start = 0
            let items = []
            while (start < 24) {
                items.push(start++)
            }
            return items
        },
        days() {
            let index = 1
            let items = []
            while (index < 8) {
                items.push({
                    id: index,
                    title: this.$t(`days_of_week.${index++ - 1}`),
                })
            }
            return items
        },
        hoursWithMin() {
            let start = 0
            let items = []
            while (start < 24) {
                items.push(`${start.toString().padStart(2, '')}:00`)
                items.push(`${start.toString().padStart(2, '')}:30`)

                start++
            }
            return items
        },
        watchedValue() {
            return Object.assign({}, this.value)
        },
    },
    watch: {
        watchedValue: {
            deep: true,
            handler(newValue, oldValue) {
                if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                    return
                }
                console.log('changed', this.value.id)
                if (this.value.id) {
                    this.$emit('onChanged', this.value.id)
                }
            },
        },
    },
    methods: {
        deleteRule() {
            this.$emit('onDelete', this.index)
            this.deleteConfirmModal = false
        },
        validateTime(value) {
            const pattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/
            return (
                pattern.test(value) ||
                this.$t('validations.messages.invalid_time')
            )
        },
        validationTimeFrom(timeTo) {
            return `from_should_be_less_than_to:${timeTo}`
        },
        validationTimeTo(timeFrom) {
            return `to_should_be_greater_than_from:${timeFrom}`
        },
    },
}
</script>

<style scoped lang="scss"></style>
